import { ITableElement } from "shared/components/interfaces/table.interface";
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { formatCurrency } from "shared/utils";
import { columnsAutorizations } from "../types";

export const columnsTableAutorizations= (isContract: boolean): ITableElement<columnsAutorizations>[] => {

  const columnsTable = [
    {
      field: 'invoiceNumber',
      headerName: 'Número de Factura',
      sortable: 'invoiceNumber',
      minWidth: 180,
      renderCell(params: columnsAutorizations) {
        return (<>{params.invoiceNumber ?? ''}</>)
      },
    },
    {
      field: 'nit',
      headerName: 'Nit',
      sortable: 'employer_id_number',
      minWidth: 120,
      renderCell(params: columnsAutorizations) {
        return (<>{ params.nit ?? '' }</>)
      },
    },
    {
      field: 'provider',
      headerName: 'Razón social',
      sortable: 'hsp_name',
      minWidth: 280,
      renderCell(params: columnsAutorizations) {
        return (<>{params.provider ?? ''}</>)
        },
    },
    {
      field: 'totalValue',
      headerName: 'Total factura',
      sortable: 'invoice_value',
      minWidth: 160,
      renderCell(params: columnsAutorizations) {
        return (<>{formatCurrency(params?.totalValue ?? 0) }</>)
        },
    },
    {
      field: 'invoiceState',
      headerName: 'Estado de la factura',
      sortable: 'invoice_state',
      minWidth: 240,
      renderCell(params: columnsAutorizations) {
        return (<>{params.invoiceState ?? ''}</>)
        },
    },
    {
      field: 'valueEndorsed',
      headerName: 'Valor de Avalado',
      sortable: 'valueEndorsed',
      minWidth: 160,
      renderCell(params: columnsAutorizations) {
        return (<>{formatCurrency(params?.valueEndorsed ?? 0) }</>)
      },
    },
    {
      field: 'valueAcceptedGloss',
      headerName: 'Valor Glosa Aceptada',
      sortable: 'valueAcceptedGloss',
      minWidth: 180,
      renderCell(params: columnsAutorizations) {
        return (<>{formatCurrency(params?.valueAcceptedGloss ?? 0)}</>)
      },
    },
    {
      field: 'valueinNoAgreement',
      headerName: 'Valor en No Acuerdo',
      sortable: 'valueinNoAgreement',
      minWidth: 170,
      renderCell(params: columnsAutorizations) {
        return (<>{formatCurrency(params?.valueinNoAgreement ?? 0) }</>)
      },
    },
    {
      field: 'authorizedBy',
      headerName: 'Auditor que autoriza',
      sortable: 'created_by_payment',
      minWidth: 220,
      renderCell(params: columnsAutorizations) {
        return (<>{params.authorizedBy ?? ''}</>)
      },
    },
    {
      field: 'paymentLine',
      headerName: 'Línea de pago',
      sortable: 'payment_line_id_payment',
      minWidth: 240,
      renderCell(params: columnsAutorizations) {
        return (<>{params.paymentLine ?? ''}</>)
      },
    },
    {
      field: 'contract',
      headerName: 'Contrato',
      sortable: 'contract',
      minWidth: 160,
      renderCell(params: columnsAutorizations) {
        return (<>{params.contract ?? ''}</>)
      },
      isHidden: isContract
    },
    //todo: futura implementacion
    // {
    //   field: 'paymentReference',
    //   headerName: 'Referencia de pago',
    //   sortable: 'payment_reference',
    //   minWidth: 170,
    //   renderCell(params: columnsAutorizations) {
    //     return (<>{params.paymentReference ?? ''}</>
    //     )
    //   },
    // },
    {
      field: 'filingNumber',
      headerName: 'Nro de radicado',
      sortable: 'filing_number',
      minWidth: 160,
      renderCell(params: columnsAutorizations) {
        return (<>{params.filingNumber ?? ''}</>)
        },
    },
    {
      field: 'initialServiceDate',
      headerName: 'Fecha Inicial Prestación de servicio',
      sortable: 'initialServiceDate',
      minWidth: 280,
      renderCell(params: columnsAutorizations) {
        return (<>{params.initialServiceDate ? dayjs(params.initialServiceDate).format('YYYY-MM-DD') : ''}</>)
      },
    },

    {
      field: 'endDateofService',
      headerName: 'Fecha Final Prestación de servicio',
      sortable: 'endDateofService',
      minWidth: 280,
      renderCell(params: columnsAutorizations) {
        return (<>{params.endDateofService ? dayjs(params.endDateofService).format('YYYY-MM-DD') : ''}</>)
      },
    },
    {
      field: 'creditNoteNumber',
      headerName: 'Número de Nota Crédito',
      sortable: 'creditNoteNumber',
      minWidth: 200,
      renderCell(params: columnsAutorizations) {
        return (<>{params.creditNoteNumber || ''}</>)
      },
    },
    {
      field: 'totalCreditNote',
      headerName: 'Total Nota Crédito',
      sortable: 'totalCreditNote',
      minWidth: 190,
      renderCell(params: columnsAutorizations) {
        return (<>{formatCurrency(params.totalCreditNote) ?? 'N/A'}</>)
      },
    },
    {
      field: 'withCertificate',
      headerName: 'Con certificado',
      sortable: 'withCertificate',
      minWidth: 140,
      renderCell(params: columnsAutorizations) {
        return (<>{params.withCertificate ? 'Si' : 'No'}</>)
      },
    }
  ];
  return columnsTable
} 
    